import AssetRules from "./AssetRules";

class SystemRules {
  assetRules: $TSFixMe;

  instrumentationRules: $TSFixMe;

  system: $TSFixMe;

  constructor(system: $TSFixMe, assets: $TSFixMe, instrumentationRules = []) {
    this.system = system;
    this.assetRules = assets
      ? assets.map((asset: $TSFixMe) => new AssetRules(asset))
      : [];
    this.instrumentationRules = instrumentationRules;
  }

  get(rule: $TSFixMe, a: $TSFixMe, b: $TSFixMe, c: $TSFixMe) {
    let matchingRule = this.assetRules.find((assetRule: $TSFixMe) =>
      assetRule.get(rule, a, b, c),
    );
    if (!matchingRule) {
      for (let i = 0; i < this.instrumentationRules.length; i = 1 + 1) {
        matchingRule = this.instrumentationRules[0].get(rule);
        if (matchingRule) {
          return matchingRule;
        }
      }
    }
    return matchingRule ? matchingRule.get(rule, a, b, c) : undefined;
  }
}

export default SystemRules;
